import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, BackHandler, Platform, StatusBar, TouchableOpacity, ScrollView, ActivityIndicator, SafeAreaView } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import { Ionicons, } from "@expo/vector-icons"
import { NativeBaseProvider, Radio, useMediaQuery, } from 'native-base';
import AwesomeAlert from 'react-native-awesome-alerts';
import { useDispatch, useSelector } from 'react-redux';
import { SetEDITservice, Setservice } from '../store/action/finalproduct';
import { useIsFocused } from '@react-navigation/native';
import { getfinalListmdf } from '../store/action/userProduct';
import { logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';










const Final = (props) => {
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const TypeMdf = useSelector((store) => store.finalproduct.datamdf);
    const dispatch = useDispatch();

    const [ERROR, setError] = useState(false);
    const [Massage, setMassage] = useState();
    const [loading, setloading] = useState(false)

    // const [Radio1, setRadio1] = useState("ورق مورد نیاز را خدماتی تهیه کند")
    const [services, setservices] = useState("ندارم")
    const [customer, setcustomer] = useState("ندارم")

    const [Radio2, setRadio2] = useState("برام ارسال کنید")
    const [name, setname] = useState("")
    const [MDF, setMDF] = useState([])



    const [State, setState] = useState({
        isLoading: false,
        isLoading1: false,


    })

    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    const ADDSERVICEHandler = async (status) => {
        try {
            if (status == "send") {
                setState({ ...State, isLoading1: true })
            } else {
                setState({ ...State, isLoading: true })
            }




            const res = await dispatch(Setservice(tokens,
                props.route.params.ids,

                name,
                services,
                customer,
                Radio2,
                status,

                props.route.params.numberic == "2" ? "" : TypeMdf[0],
                props.route.params.numberic == "2" ? "" : TypeMdf[1],
                props.route.params.numberic == "2" ? "" : TypeMdf[2],
                props.route.params.numberic == "2" ? "" : TypeMdf[3],
                props.route.params.numberic == "2" ? "" : TypeMdf[4],
                props.route.params.numberic == "2" ? "" : TypeMdf[5],
                props.route.params.numberic == "2" ? "" : TypeMdf[6],
                props.route.params.numberic == "2" ? "" : TypeMdf[7]






            ))

            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")

            } else if (res.status == "error") {
                setError(true)
                setMassage(res.message)
            }
            // console.log(res);

            setState({ ...State, isLoading: false })
            setState({ ...State, isLoading1: false })
        } catch (err) {
            // logOutHandler();
        }
    };







    const getServiceHandler = async () => {
        try {
            setloading(true)
            // setState({ ...State, isLoading: true })

            const res = await dispatch(getfinalListmdf(tokens, props.route.params.orderid));
            // console.log(res.data.data.order);



            setname(res.data.data.order.name)
            setMDF(res.data.data.order.groups)
            //setRadio1(res.data.data.order.sheet_status == null ? "ورق مورد نیاز را خدماتی تهیه کند" : res.data.data.order.sheet_status)
            setRadio2(res.data.data.order.send_status == null ? "برام ارسال کنید" : res.data.data.order.send_status)
            setservices(res.data.data.order.sheet_status_services == "ندارم" ? "ندارم" : res.data.data.order.sheet_status_services)
            setcustomer(res.data.data.order.sheet_status_customer == "ندارم" ? "ندارم" : res.data.data.order.sheet_status_customer)
            // setState({ ...State, isLoading: false })
            setloading(false)

        } catch (err) {
            // logOutHandler();
        }
    };


    // console.log(props.route.params.orderid);
    const isfocuce = useIsFocused();
    useEffect(() => {
        if (props.route.params.orderid) {
            getServiceHandler()
        }


    }, [isfocuce])





    const ADDSERVICEEDITHandler = async (status,

        wood_type,
        wood_thickness,
        panel_width,
        panel_height,
        color_strip,
        width_strip,
        height_strip,
        panel_description
    ) => {



        try {
            if (status == "send") {
                setState({ ...State, isLoading1: true })
            } else {
                setState({ ...State, isLoading: true })
            }


            const res = await dispatch(SetEDITservice(tokens,
                props.route.params.orderid,
                props.route.params.gruop_id,
                services,
                customer,
                name,
                Radio2,
                status,

                props.route.params.numberic == "2" ? "" : wood_type,
                props.route.params.numberic == "2" ? "" : wood_thickness,
                props.route.params.numberic == "2" ? "" : panel_width,
                props.route.params.numberic == "2" ? "" : panel_height,
                props.route.params.numberic == "2" ? "" : color_strip,
                props.route.params.numberic == "2" ? "" : width_strip,
                props.route.params.numberic == "2" ? "" : height_strip,
                props.route.params.numberic == "2" ? "" : panel_description,
            ))

            // console.log(res);
            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")

            } else if (res.status == "error") {
                setError(true)
                setMassage(res.message)
            }
            //console.log(res);

            setState({ ...State, isLoading: false })
            setState({ ...State, isLoading1: false })
        } catch (err) {
            // logOutHandler();;
        }
    };



    //  console.log(TypeMdf);



    function handleBackButtonClick() {

        props.navigation.goBack();
        return true;
    }


    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);









    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });

    return !loading ? (

        <NativeBaseProvider>


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft:isSmallScreen?0:"35%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            بررسی نهایی
                        </Text>
                    </TouchableOpacity>

                </View>



















                <ScrollView style={{ backgroundColor: Colors.background1, marginBottom: 65 }}>


                    <View style={styles.view}>
                        <View style={{ width: "100%", height: 40, marginRight: "5%", marginTop: 5, justifyContent: 'center' }}>
                            <Text style={styles.texttitle}>{props.route.params.name} {props.route.params.family}</Text>
                        </View>


                        <View style={styles.viewline} >
                            <Text style={styles.textlineR}>تعداد تکه : <Text style={styles.textline}>{props.route.params.totalmdf}</Text></Text>
                        </View>





                        <INPU
                            label="نام سفارش"
                            styleview={{ marginTop: "3%", height: 70, marginBottom: 10 }}
                            stylelabel={{ width: "20%", backgroundColor: "white" }}
                            value={name}
                            onChangeText={(text) => setname(text)}
                            styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                            keyboardType="default"

                        />






                        <INPU
                            label=" توضیحات ورق خدماتی"
                            multiline
                            styleinput={{ height: 100 }}
                            styleview={{ height: 100, marginBottom: "5%", marginTop: 5 }}
                            stylelabel={{ width: 140, top: Platform.OS == "web" ? -9 : -15, backgroundColor: "white" }}
                            keyboardType="default"
                            value={services}
                            onChangeText={(text) => setservices(text)}


                        //styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                        />

                        <INPU
                            label=" توضیحات ورق کاربر"
                            multiline
                            styleinput={{ height: 100 }}
                            styleview={{ height: 100, marginBottom: "2%", marginTop: 5 }}
                            stylelabel={{ width: 120, top: Platform.OS == "web" ? -9 : -15, backgroundColor: "white" }}
                            keyboardType="default"
                            value={customer}
                            onChangeText={(text) => setcustomer(text)}


                        //styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                        />



                        <View style={{ width: "100%", height: 30, }}>
                            <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "4%" }}> نحوه ارسال : </Text>
                        </View>



                        <View style={{ width: "100%", height: 85, flexDirection: "column" }}>
                            <Ionicons onPress={() => setRadio2("میام می برم")} name={Radio2 == "برام ارسال کنید" ? "ellipse-outline" : 'radio-button-on-outline'}
                                size={30} color={Radio2 == "برام ارسال کنید" ? Colors.secondText3 : Colors.primary}
                                style={{ position: "absolute", right: Platform.OS === "web" ? 7 : 15 }}
                            />
                            <Text onPress={() => setRadio2("میام می برم")} style={{ fontFamily: "Montserrat", fontSize: 15, position: "absolute", right: "16%", top: Platform.OS === "web" ? 5 : 1 }}>میام می برم  </Text>


                            <Ionicons onPress={() => setRadio2("برام ارسال کنید")} name={Radio2 == "میام می برم" ? "ellipse-outline" : 'radio-button-on-outline'}
                                size={30} color={Radio2 == "میام می برم" ? Colors.secondText3 : Colors.primary}
                                style={{ position: "absolute", right: Platform.OS === "web" ? 7 : 14, bottom: "23%", }}
                            />
                            <Text onPress={() => setRadio2("برام ارسال کنید")} style={{ fontFamily: "Montserrat", fontSize: 15, position: "absolute", right: "16%", bottom: Platform.OS === "web" ? "30%" : "28%" }}>برام ارسال کنید  </Text>
                        </View>

                    </View>
















                    <AwesomeAlert
                        show={ERROR}
                        showProgress={false}
                        title={Massage == "با موفقیت ثبت شد" ? "" : "اخطار"}
                        message={Massage}
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}
                        // showCancelButton={true}
                        showConfirmButton={true}
                        // cancelText="باشه"
                        confirmText="باشه"
                        confirmButtonColor={Colors.success}
                        // onCancelPressed={() => {
                        //   setShow(false);
                        // }}
                        onConfirmPressed={() => {
                            if (Massage == "با موفقیت ثبت شد") {
                                setError(false);
                                props.navigation.navigate("orderlist", {
                                    refresh: "true"
                                })

                            } else {
                                setError(false)
                            }

                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: "red" }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    />



                </ScrollView>


                {props.route.params.numberic == "2" ?
                    <View style={styles.viewfooter}>
                        <Btn
                            label="ادامه"
                            style={{ width: "100%", marginTop: 10, position: "absolute", left: "5%" }}
                            textStyle={{ bottom: 10, color: Colors.background }}
                            touchableStyle={{ backgroundColor: Colors.green, elevation: 0 }}
                            colorspin={Colors.background}
                            sizespin={25}
                            loading={State.isLoading1}
                            onPress={() => {
                                props.navigation.navigate("chat", {
                                    ids: props.route.params.ids, 
                                    name: name ? name : "بدون نام",
                                    services: services,
                                    customer: customer,
                                    send: Radio2,




                                })




                            }}

                        />
                    </View>

                    :

                    props.route.params.orderid
                        ?

                        MDF.map((item, i) => {
                            return (
                                <View key={i} style={styles.viewfooter}>





                                    <Btn
                                        label="ثبت موقت"
                                        style={{ width: props.route.params.orderid ? "49%" : "25%", marginTop: 10, position: "absolute", left: "5%" }}
                                        textStyle={{ bottom: 10, color: Colors.background }}
                                        touchableStyle={{ backgroundColor: Colors.primarydark, elevation: 0 }}
                                        colorspin={Colors.background}
                                        sizespin={25}
                                        loading={State.isLoading}
                                        onPress={() => {

                                            ADDSERVICEEDITHandler("pending",
                                                item.wood_type,
                                                item.wood_thickness,
                                                item.panel_width,
                                                item.panel_height,
                                                item.color_strip,
                                                item.width_strip,
                                                item.height_strip,
                                                item.panel_description


                                            )

                                        }}

                                    />



                                    <Btn
                                        label="ارسال به خدماتی"
                                        style={{ width: props.route.params.orderid ? "49%" : "40%", marginTop: 10, position: "absolute", left: props.route.params.orderid ? "52%" : "60%" }}
                                        textStyle={{ bottom: 10, color: Colors.background }}
                                        touchableStyle={{ backgroundColor: Colors.green, elevation: 0 }}
                                        colorspin={Colors.background}
                                        sizespin={25}
                                        loading={State.isLoading1}
                                        onPress={() => {

                                            ADDSERVICEEDITHandler("send",
                                                item.wood_type,
                                                item.wood_thickness,
                                                item.panel_width,
                                                item.panel_height,
                                                item.color_strip,
                                                item.width_strip,
                                                item.height_strip,
                                                item.panel_description)


                                        }}

                                    />
















                                </View>

                            )
                        })
                        :

                        <View style={styles.viewfooter}>



                            <Btn
                                label="ثبت موقت"
                                style={{ width: props.route.params.orderid ? "49%" : "25%", marginTop: 10, position: "absolute", left: "5%" }}
                                textStyle={{ bottom: 10, color: Colors.background }}
                                touchableStyle={{ backgroundColor: Colors.primarydark, elevation: 0 }}
                                colorspin={Colors.background}
                                sizespin={25}
                                loading={State.isLoading}
                                onPress={() => {

                                    ADDSERVICEHandler("pending")

                                }}

                            />



                            <Btn
                                label="ویرایش"
                                coloricon={Colors.black}
                                style={{ width: "35%", marginTop: 10, position: "absolute", left: "28%" }}
                                textStyle={{ bottom: 10 }}
                                onPress={() => props.navigation.navigate("list", {
                                    ids: "",
                                })}
                            />



                            <Btn
                                label="ارسال به خدماتی"
                                style={{ width: props.route.params.orderid ? "49%" : "40%", marginTop: 10, position: "absolute", left: props.route.params.orderid ? "52%" : "60%" }}
                                textStyle={{ bottom: 10, color: Colors.background }}
                                touchableStyle={{ backgroundColor: Colors.green, elevation: 0 }}
                                colorspin={Colors.background}
                                sizespin={25}
                                loading={State.isLoading1}
                                onPress={() =>
                                    ADDSERVICEHandler("send")

                                }

                            />



                        </View>
                }

            </View>
        </NativeBaseProvider>

    ) : (
        <NativeBaseProvider>
            <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                <ActivityIndicator
                    animating={loading} size={30} color={Colors.primary} />

                <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
            </View>
        </NativeBaseProvider>
    )
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "16%" : "36%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "13%" : "33%"
    },
    viewfooter: {
        position: "absolute",
        bottom: 0,
        flexDirection: "row",
        width: "100%",
        height: 60,
        backgroundColor: Colors.background

    },
    view: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        alignSelf: "auto",
        backgroundColor: Colors.background1,
        marginTop: 10,
        left: "5%",
        borderWidth: 2,
        borderColor: Colors.secondText,
        borderRadius: 10,
        marginBottom: 20

    },
    texttitle: {
        fontFamily: "Montserrat",
        fontSize: 15,
        color: Colors.black,
        position: "absolute",
        right: "3%",
        top: "15%"
    }, viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5

    },
    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },
    textline: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.secondText3,

    }, viewbtn: {
        width: "100%",
        height: 50,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5
    }
})




export default Final